/* ballstories Konfigurator — Schema & Enums
 *
 * Faithful port of the Vue wizard (football-storybooks/src/views/Create.vue +
 * src/lib/book.js + src/lib/optionLabels.js). Field values/enums are EXACT
 * copies of the Vue app — nothing invented.
 *
 * Exposes a single global namespace: window.BSConfigurator
 *   - ENUMS            : option lists (value/label) identical to optionLabels.js
 *   - createEmptyForm(): the form state shape (subset of book.js createEmptyForm)
 *   - buildSchema(bookType): per-book-type step/field schema driving the renderer
 *
 * The engine (bs-configurator.js) is a generic renderer over this schema, so
 * adding/altering a book type means editing the schema only.
 */
(function () {
  "use strict";
  var NS = (window.BSConfigurator = window.BSConfigurator || {});

  var ENUMS = {
    languages: [
      { value: "de", label: "Deutsch", emoji: "🇩🇪" },
      { value: "en", label: "Englisch", emoji: "🇬🇧" },
    ],
    genders: [
      { value: "male", label: "Junge", emoji: "👦" },
      { value: "female", label: "Mädchen", emoji: "👧" },
    ],
    kindergartenOrSchool: [
      { value: "kindergarten", label: "Kindergarten", emoji: "🏫" },
      { value: "school", label: "Schule", emoji: "📚" },
    ],
    hairColors: [
      { value: "blonde", label: "Blond", emoji: "🟡" },
      { value: "dark-blonde", label: "Dunkelblond", emoji: "🟤" },
      { value: "brown", label: "Braun", emoji: "🟤" },
      { value: "black", label: "Schwarz", emoji: "⚫" },
      { value: "red", label: "Rot", emoji: "🔴" },
    ],
    hairLengths: [
      { value: "very-short", label: "Ganz kurz" },
      { value: "short", label: "Kurz" },
      { value: "medium", label: "Mittel" },
      { value: "long", label: "Lang" },
      { value: "very-long", label: "Sehr lang" },
    ],
    // UI-Werte (kein 'ponytail' — das ist nur das Firestore-Speicherformat)
    hairTypes: [
      { value: "straight", label: "Glatt" },
      { value: "wavy", label: "Wellig" },
      { value: "curly", label: "Lockig" },
      { value: "coily", label: "Kraus" },
      { value: "zopf", label: "Zopf" },
    ],
    faceFeatures: [
      { value: "european", label: "Europäische" },
      { value: "east-asian", label: "Ostasiatische" },
      { value: "south-asian", label: "Südasiatische" },
      { value: "african", label: "Afrikanische" },
      { value: "arab-middle-eastern", label: "Arabische / Nahöstliche" },
      { value: "latin-american", label: "Latein-Amerikanische" },
    ],
    eyeColors: [
      { value: "blue", label: "Blau", emoji: "🔵" },
      { value: "brown", label: "Braun", emoji: "🟤" },
      { value: "green", label: "Grün", emoji: "🟢" },
      { value: "gray", label: "Grau", emoji: "⚪" },
    ],
    skinColors: [
      { value: "very light", label: "Sehr Hell", emoji: "🧒🏻" },
      { value: "light", label: "Hell", emoji: "🧒🏼" },
      { value: "medium", label: "Mittel", emoji: "🧒🏽" },
      { value: "dark", label: "Dunkel", emoji: "🧒🏾" },
      { value: "very dark", label: "Sehr Dunkel", emoji: "🧒🏿" },
    ],
    wearsGlasses: [
      { value: false, label: "Keine Brille", emoji: "🚫" },
      { value: true, label: "Trägt Brille", emoji: "👓" },
    ],
    storyStyles: [
      { value: "classic", label: "Klassisch", emoji: "📖" },
      { value: "adventurous", label: "Abenteuerlich", emoji: "🗺️" },
      { value: "wild", label: "Wild & Frech", emoji: "🌪️" },
    ],
    // Nur die im Vue-UI sichtbaren Werte (4 weitere sind dort display:none)
    learnValues: [
      { value: "courage", label: "Mut", emoji: "💪" },
      { value: "fairplay", label: "Fairplay", emoji: "🤝" },
      { value: "friendship", label: "Freundschaft", emoji: "💛" },
      { value: "team_spirit", label: "Teamgeist", emoji: "👥" },
      { value: "handling_defeat", label: "Umgang mit Niederlagen", emoji: "🙏" },
    ],
    // Nur die im normalen Step-4-Radio sichtbaren Events (WM-Events laufen über WM-Buchtyp)
    specialEvents: [
      { value: "training_camp", label: "Mehrtägiges Trainingscamp", emoji: "✨" },
      { value: "tryout_big_club", label: "Probetraining bei großem Verein", emoji: "🔥" },
      { value: "team_trip", label: "Ausflug mit der Mannschaft", emoji: "🚌" },
      { value: "tournament", label: "Großes Turnier", emoji: "🏆" },
      { value: "league_championship", label: "Saisonfinale in der Liga", emoji: "🏁" },
    ],
    positions: [
      { value: "goalkeeper", label: "Torwart", emoji: "🥅" },
      { value: "defender", label: "Verteidiger", emoji: "🛡️" },
      { value: "midfield", label: "Mittelfeld", emoji: "⚽" },
      { value: "striker", label: "Stürmer", emoji: "🎯" },
    ],
    jerseyColors: [
      { value: "red", label: "Rot", emoji: "🔴" },
      { value: "blue", label: "Blau", emoji: "🔵" },
      { value: "green", label: "Grün", emoji: "🟢" },
      { value: "yellow", label: "Gelb", emoji: "🟡" },
      { value: "white", label: "Weiß", emoji: "⚪" },
      { value: "black", label: "Schwarz", emoji: "⚫" },
      { value: "gray", label: "Grau", emoji: "🔘" },
      { value: "purple", label: "Lila", emoji: "🟣" },
      { value: "orange", label: "Orange", emoji: "🟠" },
      { value: "pink", label: "Rosa", emoji: "🩷" },
    ],
    referralSources: [
      { value: "facebook", label: "Facebook", emoji: "📘" },
      { value: "instagram", label: "Instagram", emoji: "📸" },
      { value: "zeitung", label: "Zeitung", emoji: "📄" },
      { value: "google", label: "Google", emoji: "🔍" },
      { value: "empfehlung", label: "Empfehlung", emoji: "💬" },
      { value: "sonstiges", label: "Sonstiges", emoji: "❓" },
    ],
  };
  NS.ENUMS = ENUMS;

  // Emoji palette for the dedication textarea (rendered in PDF via Noto Color Emoji).
  var DEDICATION_EMOJIS = [
    "💛", "⚽", "🏆", "✨", "💪", "🎯", "🔥", "🥅", "🙌", "😊", "🫶", "💌", "⭐", "🎂", "❤️", "🤍", "👏",
  ];
  NS.DEDICATION_EMOJIS = DEDICATION_EMOJIS;

  // ===========================================================================
  // WM 2026 Nationalmannschaften — 1:1 Port aus football-storybooks/src/lib/
  // wm2026Nations.js. `value` = flag-icons-Code (fi fi-<code>); wird als
  // story.specialEventClub in Firestore gespeichert (identisch zur Vue-App).
  // `group` steuert die <optgroup>-Gruppierung im Dropdown.
  // ===========================================================================
  var WM_NATIONS = [
    { value: "us", label: "USA (Gastgeber)", group: "Gastgeber" },
    { value: "ca", label: "Kanada (Gastgeber)", group: "Gastgeber" },
    { value: "mx", label: "Mexiko (Gastgeber)", group: "Gastgeber" },

    { value: "de", label: "Deutschland", group: "Qualifiziert (UEFA)" },
    { value: "fr", label: "Frankreich", group: "Qualifiziert (UEFA)" },
    { value: "es", label: "Spanien", group: "Qualifiziert (UEFA)" },
    { value: "pt", label: "Portugal", group: "Qualifiziert (UEFA)" },
    { value: "nl", label: "Niederlande", group: "Qualifiziert (UEFA)" },
    { value: "be", label: "Belgien", group: "Qualifiziert (UEFA)" },
    { value: "hr", label: "Kroatien", group: "Qualifiziert (UEFA)" },
    { value: "ch", label: "Schweiz", group: "Qualifiziert (UEFA)" },
    { value: "at", label: "Österreich", group: "Qualifiziert (UEFA)" },
    { value: "no", label: "Norwegen", group: "Qualifiziert (UEFA)" },
    { value: "gb-eng", label: "England", group: "Qualifiziert (UEFA)" },
    { value: "gb-sct", label: "Schottland", group: "Qualifiziert (UEFA)" },

    { value: "it", label: "Italien", group: "Noch möglich (UEFA-Playoffs)" },
    { value: "ua", label: "Ukraine", group: "Noch möglich (UEFA-Playoffs)" },
    { value: "se", label: "Schweden", group: "Noch möglich (UEFA-Playoffs)" },
    { value: "pl", label: "Polen", group: "Noch möglich (UEFA-Playoffs)" },
    { value: "al", label: "Albanien", group: "Noch möglich (UEFA-Playoffs)" },
    { value: "tr", label: "Türkei", group: "Noch möglich (UEFA-Playoffs)" },
    { value: "ro", label: "Rumänien", group: "Noch möglich (UEFA-Playoffs)" },
    { value: "sk", label: "Slowakei", group: "Noch möglich (UEFA-Playoffs)" },
    { value: "xk", label: "Kosovo", group: "Noch möglich (UEFA-Playoffs)" },
    { value: "dk", label: "Dänemark", group: "Noch möglich (UEFA-Playoffs)" },
    { value: "mk", label: "Nordmazedonien", group: "Noch möglich (UEFA-Playoffs)" },
    { value: "cz", label: "Tschechien", group: "Noch möglich (UEFA-Playoffs)" },
    { value: "ie", label: "Irland", group: "Noch möglich (UEFA-Playoffs)" },
    { value: "gb-wls", label: "Wales", group: "Noch möglich (UEFA-Playoffs)" },
    { value: "gb-nir", label: "Nordirland", group: "Noch möglich (UEFA-Playoffs)" },
    { value: "ba", label: "Bosnien und Herzegowina", group: "Noch möglich (UEFA-Playoffs)" },

    { value: "ar", label: "Argentinien", group: "Qualifiziert (CONMEBOL)" },
    { value: "br", label: "Brasilien", group: "Qualifiziert (CONMEBOL)" },
    { value: "uy", label: "Uruguay", group: "Qualifiziert (CONMEBOL)" },
    { value: "co", label: "Kolumbien", group: "Qualifiziert (CONMEBOL)" },
    { value: "ec", label: "Ecuador", group: "Qualifiziert (CONMEBOL)" },
    { value: "py", label: "Paraguay", group: "Qualifiziert (CONMEBOL)" },

    { value: "pa", label: "Panama", group: "Qualifiziert (CONCACAF)" },
    { value: "cw", label: "Curaçao", group: "Qualifiziert (CONCACAF)" },
    { value: "ht", label: "Haiti", group: "Qualifiziert (CONCACAF)" },

    { value: "dz", label: "Algerien", group: "Qualifiziert (CAF)" },
    { value: "ma", label: "Marokko", group: "Qualifiziert (CAF)" },
    { value: "sn", label: "Senegal", group: "Qualifiziert (CAF)" },
    { value: "tn", label: "Tunesien", group: "Qualifiziert (CAF)" },
    { value: "eg", label: "Ägypten", group: "Qualifiziert (CAF)" },
    { value: "gh", label: "Ghana", group: "Qualifiziert (CAF)" },
    { value: "ci", label: "Elfenbeinküste", group: "Qualifiziert (CAF)" },
    { value: "za", label: "Südafrika", group: "Qualifiziert (CAF)" },
    { value: "cv", label: "Kap Verde", group: "Qualifiziert (CAF)" },

    { value: "jp", label: "Japan", group: "Qualifiziert (AFC)" },
    { value: "kr", label: "Südkorea", group: "Qualifiziert (AFC)" },
    { value: "au", label: "Australien", group: "Qualifiziert (AFC)" },
    { value: "ir", label: "Iran", group: "Qualifiziert (AFC)" },
    { value: "sa", label: "Saudi-Arabien", group: "Qualifiziert (AFC)" },
    { value: "qa", label: "Katar", group: "Qualifiziert (AFC)" },
    { value: "uz", label: "Usbekistan", group: "Qualifiziert (AFC)" },
    { value: "jo", label: "Jordanien", group: "Qualifiziert (AFC)" },

    { value: "nz", label: "Neuseeland", group: "Qualifiziert (OFC)" },

    { value: "cd", label: "DR Kongo", group: "Noch möglich (interkontinental)" },
    { value: "iq", label: "Irak", group: "Noch möglich (interkontinental)" },
    { value: "jm", label: "Jamaika", group: "Noch möglich (interkontinental)" },
    { value: "bo", label: "Bolivien", group: "Noch möglich (interkontinental)" },
  ];
  NS.WM_NATIONS = WM_NATIONS;
  NS.wmNationLabel = function (code) {
    if (!code) return "";
    var c = String(code).trim().toLowerCase();
    for (var i = 0; i < WM_NATIONS.length; i++) {
      if (WM_NATIONS[i].value === c) return WM_NATIONS[i].label;
    }
    return code;
  };

  // ===========================================================================
  // FORM-STATE — Teilmenge von book.js createEmptyForm (Felder der Steps 1–4 + Abschluss)
  // ===========================================================================
  NS.createEmptyForm = function () {
    return {
      child: {
        name: "",
        lastname: "",
        birthday: "",
        gender: "",
        kindergartenOrSchool: "",
        hairColor: "",
        hairLength: "",
        hairType: "",
        faceFeatures: "",
        skinColor: "",
        eyeColor: "",
        wearsGlasses: false,
        previewImageUrl: null,
        city: "",
        cityDetails: null,
        cityManual: false,
        cityManualText: "",
        siblings: [],
      },
      club: {
        name: "",
        team: "",
        jerseyNumber: "",
        jerseyColor: "",
        position: "",
        teammates: [],
        rivals: [],
        trainers: [{ name: "", gender: "", parentRole: null }],
      },
      story: {
        language: "de",
        specialEvents: null,
        specialEventClub: null,
        storyStyle: "classic",
        learnValues: null,
        customerHighlights: null,
      },
      customer: {
        referralSource: null,
        acceptedMarketing: true,
      },
      addons: [],
      addonDetails: {
        personalAnecdote: { active: false, besonderheit1: "", besonderheit2: "", besonderheit3: "" },
        specialEvent: { active: false },
        dedication: { active: false, text: "", fromName: "", imageUrl: "", photoConsent: false },
      },
      // Vereins-Landing-Kontext (Phase 5.1b). Gesetzt von _maybeApplyClub, wenn der
      // Konfigurator mit `?club=<handle>` geoeffnet wird. Steuert Vorbefuellung +
      // Sichtbarkeit (Camp blendet Events + Geheimzutat aus) und fliesst als
      // fromClubLanding/clubSlug/customerHighlights/customLogoUrl in den Payload.
      _club: {
        fromLanding: false,
        slug: null,
        name: null,
        logoUrl: null,
        promptDetails: null,
        hideSpecialEvents: false,
        hidePersonalAnecdote: false,
      },
    };
  };

  // ===========================================================================
  // VALIDIERUNG — Helfer (faithful zu book.js)
  // ===========================================================================
  var MIN_BOOK_AGE = 5;

  function calcAge(value) {
    if (!value) return null;
    var b = new Date(value);
    if (isNaN(b.getTime())) return null;
    var t = new Date();
    var age = t.getFullYear() - b.getFullYear();
    var m = t.getMonth() - b.getMonth();
    if (m < 0 || (m === 0 && t.getDate() < b.getDate())) age -= 1;
    return age;
  }
  NS.calcAge = calcAge;

  // Default for the always-visible Kindergarten/Schule chips. Age 6 is the
  // typical German school-start year; parents can override (early/late enrollment).
  function suggestKindergartenOrSchool(age) {
    if (age == null || age < 0) return "";
    return age >= 6 ? "school" : "kindergarten";
  }
  NS.suggestKindergartenOrSchool = suggestKindergartenOrSchool;

  function validateBirthday(form) {
    var v = form.child.birthday;
    if (!v) return "Bitte gib den Geburtstag des Kindes an.";
    var age = calcAge(v);
    if (age === null || age < 0) return "Bitte gib ein gültiges Geburtsdatum an.";
    if (age < MIN_BOOK_AGE)
      return "Unsere Bücher sind erst ab 5 Jahren. Bitte gib ein Geburtsdatum für ein Kind ab 5 Jahren an.";
    return "";
  }

  function isWm(ctx) {
    return ctx && ctx.bookType === "wm";
  }
  function isSaisonauftakt(ctx) {
    return ctx && ctx.bookType === "saisonauftakt";
  }
  // Erstleser (Leseanfänger): eigener Buchtyp → story.readingMode='beginner'.
  // Bewusst ohne Schreibstil- und Event-Auswahl (auch kein WM) und nur DE.
  function isErstleser(ctx) {
    return ctx && ctx.bookType === "erstleser";
  }

  function isPersonalAnecdoteActive(form) {
    return !!(form && form.addonDetails && form.addonDetails.personalAnecdote && form.addonDetails.personalAnecdote.active);
  }
  NS.isPersonalAnecdoteActive = isPersonalAnecdoteActive;

  function isDedicationActive(form) {
    return !!(form && form.addonDetails && form.addonDetails.dedication && form.addonDetails.dedication.active);
  }
  NS.isDedicationActive = isDedicationActive;

  function isSpecialEventActive(form) {
    return !!(form && form.addonDetails && form.addonDetails.specialEvent && form.addonDetails.specialEvent.active);
  }
  NS.isSpecialEventActive = isSpecialEventActive;

  // Default app config (mirrors app/lib/configurator-settings.server.js).
  var DEFAULT_CONFIG = {
    addons: {
      special_event: {
        enabled: true,
        collapsed: false,
        variantId: "58013291839820",
        emoji: "🎯",
        title: "Besonderes Event",
        hint: "Wähle ein besonderes Event für noch mehr Abenteuer in deinem Buch.",
        infoLabel: "Mehr erfahren",
        infoTitle: "Mehr Abenteuer in der Geschichte.",
        info:
          "Mit einem besonderen Event wird deine Geschichte noch spannender – ob Trainingscamp, Turnier oder Probetraining bei einem großen Verein.",
      },
      personal_anecdote: {
        enabled: true,
        collapsed: true,
        variantId: "57848241094988",
        emoji: "✨",
        title: "Eure Geheimzutat",
        hint: "Baue eure ganz eigenen Ideen, Anekdoten und Besonderheiten in die Geschichte ein.",
        infoLabel: "Mehr erfahren",
        infoTitle: "Kleine Details, die nur ihr kennt.",
        info:
          "Tragt ein, was euer Kind besonders macht – wir verweben es als kleine, kindgerechte Details in die Geschichte.\n\n" +
          "Beispiele:\n" +
          "• Maxi ist Arsenal-London-Fan\n" +
          "• Maxi geht auf die Gesamtschule XYZ in Frankfurt\n" +
          "• Maxi geht gern mit Oma und Opa campen\n\n" +
          "Wichtige Hinweise:\n" +
          "• Keine Rechtsverletzungen / keine illegalen oder beleidigenden Inhalte.\n" +
          "• Keine sensiblen Daten (Telefon, Adresse, E-Mail, Klarnamen Dritter, Gesundheitsdaten).\n" +
          "• Review vorbehalten: Wir können Inhalte kürzen, umformulieren oder ablehnen.\n" +
          "• Du bestätigst, dass du die Rechte an deinen Angaben hast.",
      },
      dedication: {
        enabled: true,
        collapsed: true,
        variantId: "57992041136460",
        emoji: "💌",
        title: "Persönliche Widmung",
        hint: "Eine persönliche Widmung auf einer eigenen Seite ganz vorne im Buch – optional mit Foto.",
        infoLabel: "Mehr erfahren",
        infoTitle: "Eine eigene Seite ganz vorne im Buch.",
        info:
          "Deine Widmung erscheint auf einer eigenen Seite direkt vor dem Vorwort.\n\n" +
          "• Bis zu 300 Zeichen Text.\n" +
          "• Optional ein Absender („von …“).\n" +
          "• Optional ein Foto (z. B. von euch), das schön eingebunden wird.\n\n" +
          "Hinweise: keine sensiblen Daten oder Rechte Dritter; Review vorbehalten.",
      },
    },
    stepTexts: {
      storyTitle: "🎯 Werte und persönliche Extras",
      learnValuesLabel: "Werte-Botschaft",
      learnValuesNone: "Ohne Werte-Botschaft",
      specialEventsLabel: "Besonderes Event",
      specialEventsNone: "Ohne besonderes Event",
    },
    featureFlags: {
      dedicationEnabled: true,
      specialEventEnabled: true,
    },
    infrastructure: {
      functionsBase: "https://europe-west3-football-storybooks.cloudfunctions.net",
      cartRedirect: "/checkout",
      storageBucket: "football-storybooks.firebasestorage.app",
    },
    folgebuchVariants: [
      { label: "Klassisch", book_type: "standard", variant_id: "57848228839756" },
      { label: "WM 2026", book_type: "wm", variant_id: "57848228872524" },
    ],
  };

  function mergeConfig(raw) {
    if (!raw || typeof raw !== "object") return JSON.parse(JSON.stringify(DEFAULT_CONFIG));
    var out = JSON.parse(JSON.stringify(DEFAULT_CONFIG));
    function deep(base, patch) {
      if (!patch || typeof patch !== "object") return;
      Object.keys(patch).forEach(function (k) {
        if (patch[k] && typeof patch[k] === "object" && !Array.isArray(patch[k]) && base[k] && typeof base[k] === "object") {
          deep(base[k], patch[k]);
        } else if (patch[k] !== undefined) {
          base[k] = patch[k];
        }
      });
    }
    deep(out, raw);
    return out;
  }
  NS.mergeConfig = mergeConfig;

  function addonCfg(ctx, id) {
    return (ctx.config && ctx.config.addons && ctx.config.addons[id]) || DEFAULT_CONFIG.addons[id] || {};
  }

  // Setzt addonDetails.*.active=true für Addons mit collapsed:false (aufgeklappt),
  // ohne Inhalte vorzubelegen. Nur für frische Formulare (nicht Edit/Hydration).
  NS.applyAddonExpandDefaults = function (form, ctx) {
    if (!form || !form.addonDetails) return;

    function shouldExpand(addonId) {
      var cfg = addonCfg(ctx, addonId);
      if (cfg.enabled === false) return false;
      if (cfg.collapsed !== false) return false;
      return true;
    }

    if (
      shouldExpand("special_event") &&
      ctx.specialEventEnabled &&
      !isWm(ctx) &&
      !isSaisonauftakt(ctx) &&
      !isErstleser(ctx) &&
      !(form._club && form._club.hideSpecialEvents)
    ) {
      form.addonDetails.specialEvent.active = true;
    }

    if (shouldExpand("personal_anecdote") && !(form._club && form._club.hidePersonalAnecdote)) {
      form.addonDetails.personalAnecdote.active = true;
    }

    if (shouldExpand("dedication") && ctx.dedicationEnabled) {
      form.addonDetails.dedication.active = true;
    }
  };

  function addonCardLabel(ctx, id) {
    var cfg = addonCfg(ctx, id);
    var parts = [];
    if (cfg.emoji) parts.push(cfg.emoji);
    if (cfg.title) parts.push(cfg.title);
    return parts.join(" ");
  }

  function stepText(ctx, key, fallback) {
    return (ctx.config && ctx.config.stepTexts && ctx.config.stepTexts[key]) || fallback;
  }

  // ===========================================================================
  // SCHEMA-Bausteine
  // ===========================================================================
  function chips(path, label, optionsKey, opts) {
    opts = opts || {};
    return Object.assign(
      { type: "chips", path: path, label: label, options: ENUMS[optionsKey] },
      opts
    );
  }
  function text(path, label, opts) {
    return Object.assign({ type: "text", path: path, label: label }, opts || {});
  }
  // Gruppiertes Dropdown (<select> mit <optgroup>). options = [{value,label,group}].
  function select(path, label, options, opts) {
    return Object.assign(
      { type: "select", path: path, label: label, options: options },
      opts || {}
    );
  }
  function addonCard(addonId, path, ctx, opts) {
    opts = opts || {};
    var cfg = addonCfg(ctx, addonId);
    return Object.assign(
      {
        type: "addonCard",
        addonId: addonId,
        path: path,
        label: addonCardLabel(ctx, addonId),
        hint: cfg.hint || opts.defaultHint || "",
        info: cfg.info || opts.defaultInfo || "",
        infoLabel: cfg.infoLabel || opts.infoLabel || ((cfg.info || opts.defaultInfo) ? "Mehr erfahren" : ""),
        infoTitle: cfg.infoTitle || opts.infoTitle || "",
        rerender: true,
        children: opts.children || [],
      },
      opts.showIf ? { showIf: opts.showIf } : {}
    );
  }

  // ===========================================================================
  // STANDARD-BUCH (Steps 1–4 + Abschluss)
  // ===========================================================================
  function standardSteps(ctx) {
    return [
      // ---- STEP 1: Über dein Kind ------------------------------------------
      {
        id: "child",
        lead: "Los geht's",
        title: "😊 Erzähl uns von deinem kleinen Fußballstar",
        fields: [
          chips("story.language", "Sprache des Buches", "languages", {
            infoLabel: "Mehr zur Sprache",
            infoTitle: "Deutsch oder Englisch zum Mitlernen.",
            info:
              "Die englische Version ist altersgerecht auf Niveau der 5. Klasse geschrieben und enthält am Buchende eine Vokabelliste. So eignet sie sich ideal zum spielerischen Englischlernen.",
            // Erstleser (beginner) wird nur auf Deutsch angeboten → Sprachauswahl ausblenden
            // (Default 'de' bleibt gesetzt; Backend unterstützt beginner nur für DE).
            showIf: function () {
              return !isErstleser(ctx);
            },
          }),
          // WM-Lieblingsteam (nur WM-Buch, Pflicht). Wert = Länder-Code (z.B. "de",
          // "gb-eng") -> story.specialEventClub -> Cover-Badge im Backend (wie Vue).
          select("story.specialEventClub", "WM-Lieblingsteam", WM_NATIONS, {
            required: true,
            placeholder: "Land wählen …",
            hint: "Die Nationalmannschaft erscheint auf dem exklusiven WM-Cover-Badge.",
            showIf: function () {
              return isWm(ctx);
            },
          }),
          text("child.name", "Vorname des Kindes", {
            required: true,
            placeholder: "z. B. Max",
            // Buch-Teaser-Titel auf Seite 1 live beim Tippen mitziehen.
            syncBookTitle: true,
          }),
          text("child.lastname", "Nachname des Kindes", {
            required: true,
            infoLabel: "Warum brauchen wir den Nachnamen?",
            infoTitle: "Nur zur Unterscheidung – angesprochen wird dein Kind mit dem Vornamen.",
            info:
              "In der Geschichte kommen echte Freunde und Mitspieler vor. Heißt einer davon genauso wie dein Kind, brauchen wir eine Möglichkeit, die beiden auseinanderzuhalten.\n\nDer Nachname steht nicht auf dem Cover und wird im Buch nicht als Anrede benutzt.\n\nDu musst nicht den echten Namen angeben – ein erfundener funktioniert genauso gut. Bestellst du später ein Folgebuch, nimm dann bitte denselben, damit alle Bücher deines Kindes in deinem Bücherregal zusammenbleiben.",
          }),
          {
            type: "date",
            path: "child.birthday",
            label: "Geburtstag",
            required: true,
            infoLabel: "Warum brauchen wir das Geburtsdatum?",
            infoTitle: "Es steuert die Sprachstufe – im Buch steht es nicht.",
            info:
              "Aus dem Geburtsdatum berechnen wir die Lesestufe nach dem CEFR-Standard (europäischer Referenzrahmen für Sprachen). Sie legt fest, wie lang die Sätze sind und welche Wörter vorkommen – und damit, ob dein Kind selbst liest oder frustriert aufgibt.\n\nIm Buch steht weder das Datum noch das Alter.\n\nSteht der Geburtstag kurz bevor, priorisieren wir die Bucherstellung – dafür brauchen wir das echte Datum.\n\nGespeichert wird es auf EU-Servern, nur für unseren eigenen Service – nicht für Dritte.",
            validate: function (form) {
              return validateBirthday(form);
            },
          },
          chips("child.kindergartenOrSchool", "Kindergarten oder Schule?", "kindergartenOrSchool", {
            required: true,
            hint: "Vorausgewählt nach dem Geburtsdatum – bitte anpassen, falls es nicht stimmt.",
          }),
          chips("child.gender", "Geschlecht", "genders", { required: true }),
          chips("story.storyStyle", "Schreibstil", "storyStyles", {
            infoLabel: "Was ist der Schreibstil?",
            infoTitle: "Drei Töne – derselbe Inhalt, andere Erzählweise.",
            info:
              "**Klassisch**\nTraditionelle, einfühlsame Erzählweise mit klaren Botschaften.\n\n**Abenteuerlich**\nBildhafte, lebendige Sprache mit Metaphern und Spannungsaufbau, Szenen dramatischer zugespitzt.\n\n**Wild & Frech**\nDirekt, draufgängerisch und voller Action – mit viel Energie und Attitude. Empfohlen ab ca. 9 Jahren.",
            showIf: function (form) {
              // Kein Schreibstil bei WM und Erstleser (Erstleser erzwingt classic).
              return form.story.language === "de" && !isWm(ctx) && !isErstleser(ctx);
            },
          }),
          // Buch-Teaser bereits auf Seite 1: zeigt das angedeutete Buch mit
          // schwarzer Silhouette + dynamischem Titel. Reiner Teaser (kein
          // Generieren-Button) – die echte KI-Vorschau folgt in Step 2.
          { type: "preview", path: "child.previewImageUrl", label: "Vorschau", teaser: true },
        ],
      },

      // ---- STEP 2: Aussehen + KI-Preview -----------------------------------
      {
        id: "appearance",
        title: "✨ Wie sieht dein Kind aus?",
        fields: [
          chips("child.hairColor", "Haarfarbe", "hairColors", { required: true }),
          chips("child.hairLength", "Haarlänge", "hairLengths", { required: true }),
          chips("child.hairType", "Haartyp", "hairTypes", { required: true }),
          chips("child.eyeColor", "Augenfarbe", "eyeColors", { required: true }),
          chips("child.skinColor", "Hautton", "skinColors", { required: true }),
          chips("child.faceFeatures", "Gesichtszüge", "faceFeatures", {
            required: true,
            infoLabel: "Was bedeutet das?",
            infoTitle: "Nur für die Illustration.",
            info:
              "Diese Auswahl hilft uns, dein Kind in der Buchillustration wiedererkennbar zu zeichnen – in der Vorschau und später im Buch. Wir nutzen die Angabe zusammen mit Hautton, Haarfarbe und Augenfarbe ausschließlich für visuelle Konsistenz (Gesichtsform, Proportionen).\n\nBitte wähle die Option, die sich für euch am passendsten anfühlt. Wenn keine perfekt passt, nimm die nächste – wichtiger ist uns eine stimmige, kindgerechte Darstellung als eine exakte Kategorie.\n\nWichtig: In der Geschichte selbst spielt diese Auswahl keine Rolle. Dein Kind wird nicht danach beschrieben, benannt oder eingeordnet. Es geht nur darum, dass die Bilder stimmig wirken.",
            infoAction: {
              type: "appearance_mismatch",
              prefix: "Passt gar nichts? ",
              label: "Melde dich kurz bei uns",
              suffix: " – wir melden uns!",
            },
          }),
          chips("child.wearsGlasses", "Brille", "wearsGlasses"),
          { type: "preview", path: "child.previewImageUrl", label: "Vorschau" },
        ],
      },

      // ---- STEP 3: Fußball-Welt --------------------------------------------
      {
        id: "club",
        title: "⚽ Die Fußball-Welt deines Kindes",
        fields: [
          {
            type: "city",
            path: "child.city",
            label: "Wohnort",
            required: true,
            infoLabel: "Warum brauchen wir den Wohnort?",
            infoTitle: "Damit die Geschichte in der Welt deines Kindes spielt – nicht für den Versand.",
            info:
              "Aus dem Wohnort holen wir echte Orte und regionale Bezüge: Plätze, Parks, lokale Eigenheiten. So kommt dein Kind in der Geschichte an Stellen vor, die es kennt.\n\nDie Lieferadresse kommt erst später an der Kasse. Hier geht es nur um die Geschichte.\n\nBitte wähle den Ort zuerst aus der Liste. Steht eure Stadt nicht drin, nutze den Link „Deine Stadt ist nicht dabei?“ unter dem Feld.",
          },
          text("club.name", "Verein", { required: true }),
          text("club.team", "Mannschaft", {
            hint: "optional, z. B. F-Jugend, Bambini",
          }),
          {
            type: "list",
            path: "club.trainers",
            label: "Trainer",
            min: 1,
            max: 5,
            addLabel: "Weiteren Trainer hinzufügen",
            requiredMsg: "Bitte gib mindestens einen Trainer an.",
            item: "trainer",
          },
          text("club.jerseyNumber", "Trikotnummer", {
            required: true,
            inputmode: "numeric",
            maxlength: 2,
            pattern: "[1-9][0-9]?",
            validate: function (form) {
              var n = Number(form.club.jerseyNumber);
              if (!isFinite(n) || n < 1 || n > 99)
                return "Bitte eine Trikotnummer zwischen 1 und 99.";
              return "";
            },
          }),
          chips("club.jerseyColor", "Trikotfarbe", "jerseyColors", { required: true }),
          chips("club.position", "Lieblingsposition", "positions", { required: true }),
          {
            type: "list",
            path: "club.teammates",
            label: "Mitspieler",
            min: 1,
            max: 5,
            addLabel: "Mitspieler hinzufügen",
            requiredMsg: "Bitte gib mindestens einen Mitspieler an.",
            item: "teammate",
          },
          {
            type: "list",
            path: "club.rivals",
            label: "Rivalen / Gegner-Vereine",
            min: 0,
            max: 3,
            addLabel: "Gegner hinzufügen",
            item: "rival",
            infoLabel: "Warum empfehlen wir Rivalen?",
            infoTitle: "Mit echten Gegnern wird das Finale persönlich – ohne Angabe erfinden wir einen.",
            info:
              "In fast jeder Geschichte gibt es ein entscheidendes Spiel. Wenn du den Verein angibst, gegen den euer Kind wirklich spielt, steht genau der im Finale.\n\nDas Feld ist freiwillig. Lässt du es leer, erfinden wir einen fiktiven Gegner – keinen echten Verein aus eurer Gegend.\n\nDen Namen musst du nicht offiziell kennen. So, wie ihr den Gegner nennt, reicht völlig.",
          },
          {
            type: "list",
            path: "child.siblings",
            label: "Geschwister",
            hint: "optional – Name, Alter und Geschlecht",
            min: 0,
            max: 3,
            addLabel: "Geschwister hinzufügen",
            item: "sibling",
          },
        ],
      },

      // ---- STEP 4: Events & Botschaften (überspringbar) --------------------
      {
        id: "story",
        title: stepText(ctx, "storyTitle", "🎯 Werte und persönliche Extras"),
        fields: [
          chips("story.learnValues", stepText(ctx, "learnValuesLabel", "Werte-Botschaft"), "learnValues", {
            nullable: true,
            noneOption: stepText(ctx, "learnValuesNone", "Ohne Werte-Botschaft"),
            infoLabel: "Was bedeutet Werte-Botschaft?",
            infoTitle: "Mehr als ein schöner Satz – ein roter Faden durch die Geschichte.",
            info:
              "Fußball ist mehr als Tore schießen. Mit der Werte-Botschaft wählst du optional einen Kern, der die Geschichte trägt – zum Beispiel Mut, Fairplay, Freundschaft, Teamgeist oder Umgang mit Niederlagen.\n\nWas passiert damit? Der Wert wird nicht als Lehrertext erklärt. Er zieht sich als roter Faden durch die Handlung: Entscheidungen, Konflikte und Momente im Training oder im Spiel – so, dass dein Kind die Botschaft beim Lesen erlebt, statt sie vorgelesen zu bekommen.\n\nWas ist das Besondere bei ballstories? Jeder Wert ist bei uns inhaltlich durchdacht und altersgerecht formuliert – ohne Belehrung, mit positivem Ton. Der gewählte Wert zieht sich deshalb konsequent durch die Geschichte: in Wendepunkten, im Training und im entscheidenden Spiel – nicht nur in einer einzelnen Szene am Rand.\n\nOptional: Du kannst auch „Ohne Werte-Botschaft“ wählen. Das Buch funktioniert dann genauso – nur ohne diesen zusätzlichen inhaltlichen Fokus. (Bei englischen Büchern ist die Werte-Auswahl nicht verfügbar.)",
            disabledIf: function (form) {
              return form.story.language === "en";
            },
          }),
          addonCard("special_event", "addonDetails.specialEvent.active", ctx, {
            showIf: function (form) {
              return (
                ctx.specialEventEnabled &&
                !isWm(ctx) &&
                !isSaisonauftakt(ctx) &&
                !isErstleser(ctx) &&
                !(form._club && form._club.hideSpecialEvents)
              );
            },
            children: [
              chips("story.specialEvents", stepText(ctx, "specialEventsLabel", "Besonderes Event"), "specialEvents", {
                options: ctx.isFolgebuch
                  ? ENUMS.specialEvents.concat([{ value: "season_start", label: "Saisonauftakt", emoji: "🌅" }])
                  : ENUMS.specialEvents,
                validate: function (form) {
                  if (!isSpecialEventActive(form)) return "";
                  if (!form.story.specialEvents) {
                    return "Besonderes Event: Bitte ein Event auswählen (oder das Extra abwählen).";
                  }
                  return "";
                },
              }),
              text("story.specialEventClub", "Name des großen Vereins", {
                maxlength: 100,
                required: true,
                showIf: function (form) {
                  return isSpecialEventActive(form) && form.story.specialEvents === "tryout_big_club";
                },
              }),
            ],
          }),
          addonCard("personal_anecdote", "addonDetails.personalAnecdote.active", ctx, {
            showIf: function (form) {
              return !(form._club && form._club.hidePersonalAnecdote);
            },
            children: [
              text("addonDetails.personalAnecdote.besonderheit1", "Besonderheit 1", {
                maxlength: 120,
                placeholder: "z. B. liebt Pizza nach dem Training",
                showIf: function (form) {
                  return isPersonalAnecdoteActive(form);
                },
                validate: function (form) {
                  if (!isPersonalAnecdoteActive(form)) return "";
                  var d = form.addonDetails.personalAnecdote;
                  var any = ["besonderheit1", "besonderheit2", "besonderheit3"].some(function (k) {
                    return String((d && d[k]) || "").trim();
                  });
                  return any ? "" : "Geheimzutat: Bitte mindestens eine der drei Besonderheiten ausfüllen (oder das Extra abwählen).";
                },
              }),
              text("addonDetails.personalAnecdote.besonderheit2", "Besonderheit 2 (optional)", {
                maxlength: 120,
                showIf: function (form) {
                  return isPersonalAnecdoteActive(form);
                },
              }),
              text("addonDetails.personalAnecdote.besonderheit3", "Besonderheit 3 (optional)", {
                maxlength: 120,
                showIf: function (form) {
                  return isPersonalAnecdoteActive(form);
                },
              }),
            ],
          }),
          addonCard("dedication", "addonDetails.dedication.active", ctx, {
            showIf: function () {
              return !!ctx.dedicationEnabled;
            },
            children: [
              {
                type: "textarea",
                path: "addonDetails.dedication.text",
                label: "Widmungstext",
                maxlength: 300,
                emojis: DEDICATION_EMOJIS,
                emojiHint: "Emojis antippen zum Einfügen:",
                placeholder:
                  "z. B. Für unseren Maxi – bleib wie du bist und hab weiter so viel Spaß beim Kicken!",
                showIf: function (form) {
                  return isDedicationActive(form);
                },
                validate: function (form) {
                  if (!isDedicationActive(form)) return "";
                  var t = String((form.addonDetails.dedication && form.addonDetails.dedication.text) || "").trim();
                  if (!t) return "Widmung: Bitte einen Widmungstext eingeben (oder das Extra abwählen).";
                  if (t.length > 300) return "Widmung: Bitte höchstens 300 Zeichen.";
                  return "";
                },
              },
              text("addonDetails.dedication.fromName", "Von (optional)", {
                maxlength: 120,
                placeholder: "z. B. Oma & Opa",
                showIf: function (form) {
                  return isDedicationActive(form);
                },
              }),
              {
                type: "file",
                path: "addonDetails.dedication.imageUrl",
                consentPath: "addonDetails.dedication.photoConsent",
                label: "Foto (optional)",
                hint: "Quer- oder Hochformat. Wird dezent auf der Widmungsseite eingebunden.",
                disclaimer:
                  "Mit dem Hochladen bestätigst du, dass du die Rechte am Foto hast und alle abgebildeten Personen (bei Kindern deren Erziehungsberechtigte) mit der Nutzung im Buch einverstanden sind. Bitte keine anstößigen oder rechtswidrigen Inhalte. Das Foto wird ausschließlich zur Erstellung deines Buches verarbeitet.",
                infoLabel: "Hinweise zum Foto",
                infoTitle: "Nur mit Rechten und Einwilligung.",
                info:
                  "Foto-Upload – bitte beachten:\n\n" +
                  "• Rechte / Urheberrecht: Lade nur Fotos hoch, an denen du die Rechte hast – eigene Aufnahme oder ausdrückliche Nutzungserlaubnis.\n" +
                  "• Einwilligung: Alle abgebildeten Personen müssen mit der Verwendung einverstanden sein; bei Kindern die Erziehungsberechtigten.\n" +
                  "• Inhalte: Keine anstößigen, gewaltverherrlichenden, diskriminierenden oder rechtswidrigen Motive. Wir behalten uns vor, ungeeignete Fotos abzulehnen.\n" +
                  "• Datenschutz: Das Foto wird ausschließlich zur Erstellung deines personalisierten Buches verarbeitet, auf EU-Servern gespeichert und nicht an Dritte weitergegeben.",
                showIf: function (form) {
                  return isDedicationActive(form);
                },
              },
            ],
          }),
        ],
      },

      // ---- ABSCHLUSS: reine Bestätigung + Cart-CTA -------------------------
      // Referral ("Wie hast du von uns erfahren?") und Newsletter-Consent werden
      // bewusst NICHT mehr hier abgefragt: beides gehört in den Shopify-Checkout
      // (Newsletter = natives Marketing-Opt-in, Referral = Checkout-Survey).
      {
        id: "finish",
        title: "🎁 Fast geschafft – leg dein Buch in den Warenkorb",
        fields: [],
        isFinal: true,
      },
    ];
  }

  // ===========================================================================
  // buildSchema(bookType)
  // ===========================================================================
  NS.buildSchema = function (bookType, opts) {
    var config = mergeConfig((opts && opts.config) || (typeof window !== "undefined" && window.BS_CONFIGURATOR_CONFIG));
    var addonAnecdoteVariantId = (opts && opts.addonAnecdoteVariantId) || "";
    var dedicationVariantId = (opts && opts.dedicationVariantId) || "";
    var specialEventVariantId = (opts && opts.specialEventVariantId) || "";
    var ctx = {
      bookType: bookType || "standard",
      isFolgebuch: !!(opts && opts.isFolgebuch),
      config: config,
      dedicationEnabled:
        !!(config.featureFlags && config.featureFlags.dedicationEnabled) &&
        !!(dedicationVariantId || (config.addons && config.addons.dedication && config.addons.dedication.variantId)),
      specialEventEnabled:
        !!(config.featureFlags && config.featureFlags.specialEventEnabled) &&
        !!(specialEventVariantId || (config.addons && config.addons.special_event && config.addons.special_event.variantId)) &&
        !!(config.addons && config.addons.special_event && config.addons.special_event.enabled !== false),
    };
    return {
      bookType: ctx.bookType,
      steps: standardSteps(ctx),
    };
  };
})();
